import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { AssistantMessageType } from "@components/AssistantChat/type";

type MessagesState = {
  messages: Record<string, AssistantMessageType[]>;
  loading: Record<string, boolean>;
  fetchedConversations: Record<string, boolean>;
};

const initialState: MessagesState = {
  messages: {},
  loading: {},
  fetchedConversations: {},
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setMessages: (
      state,
      action: PayloadAction<{
        conversationId: string;
        messages: AssistantMessageType[];
      }>
    ) => {
      const { conversationId, messages } = action.payload;
      state.messages[conversationId] = messages;
      state.fetchedConversations[conversationId] = true;
    },
    setLoading: (
      state,
      action: PayloadAction<{ conversationId: string; loading: boolean }>
    ) => {
      const { conversationId, loading } = action.payload;
      state.loading[conversationId] = loading;
    },
    clearMessages: (state) => {
      state.messages = {};
      state.loading = {};
      state.fetchedConversations = {};
    },
    addMessage: (
      state,
      action: PayloadAction<{ conversationId: string; message: AssistantMessageType }>
    ) => {
      const { conversationId, message } = action.payload;
      if (!state.messages[conversationId]) {
        state.messages[conversationId] = [];
      }
      state.messages[conversationId].push(message);
    },
    updateMessage: (
      state,
      action: PayloadAction<{
        conversationId: string;
        messageId: string;
        content: string;
      }>
    ) => {
      const { conversationId, messageId, content } = action.payload;
      const messages = state.messages[conversationId];
      if (messages) {
        const msg = messages.find((m) => m.id === messageId);
        if (msg) {
          msg.content = content;
          msg.text = typeof content === "string" ? content : "";
        }
      }
    },
  },
});

export const { setMessages, setLoading, clearMessages, addMessage, updateMessage } =
  messagesSlice.actions;
export default messagesSlice.reducer;
